var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    { staticStyle: { "background-color": "#101010" } },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            "show-close": false,
            visible: _vm.contactDialogVisible,
            center: "",
            "custom-class": "contact-dialog",
            title: "",
            width: "340px"
          },
          on: {
            "update:visible": function($event) {
              _vm.contactDialogVisible = $event
            }
          },
          scopedSlots: _vm._u([
            {
              key: "title",
              fn: function() {
                return [
                  _c("div", { staticClass: "contact-title" }, [
                    _vm._v("\n        Contact agent\n        "),
                    _c(
                      "div",
                      { staticClass: "icon", on: { click: _vm.closeContact } },
                      [_c("i", { staticClass: "el-icon-close" })]
                    )
                  ])
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    model: _vm.form,
                    rules: _vm.rules,
                    "label-position": "top",
                    "label-width": "100px"
                  },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                    }
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "Name", prop: "name" } },
                    [
                      _c("el-input", {
                        attrs: { maxlength: "50", placeholder: "Your name" },
                        model: {
                          value: _vm.form.name,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "name", $$v)
                          },
                          expression: "form.name"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "Email", prop: "email" } },
                    [
                      _c("el-input", {
                        attrs: { maxlength: "100", placeholder: "Your email" },
                        model: {
                          value: _vm.form.email,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "email", $$v)
                          },
                          expression: "form.email"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "Phone number", prop: "phoneNumber" } },
                    [
                      _c("el-input", {
                        attrs: {
                          maxlength: "20",
                          placeholder: "Your phone number"
                        },
                        on: {
                          input: function($event) {
                            return _vm.validate("phone")
                          }
                        },
                        model: {
                          value: _vm.form.phoneNumber,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "phoneNumber", $$v)
                          },
                          expression: "form.phoneNumber"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "Message", prop: "message" } },
                    [
                      _c("el-input", {
                        attrs: { maxlength: "1000", placeholder: "Message" },
                        model: {
                          value: _vm.form.message,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "message", $$v)
                          },
                          expression: "form.message"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { staticStyle: { "text-align": "center" } },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "submit-button",
                          on: {
                            click: function($event) {
                              return _vm.onSubmit("form")
                            }
                          }
                        },
                        [
                          _vm._v("Confirm\n            "),
                          _vm.loading
                            ? _c("i", { staticClass: "el-icon-loading" })
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("img", {
        staticClass: "background-image",
        attrs: {
          loading: "lazy",
          src: require("../../assets/reserve-the-property.jpg")
        }
      }),
      _vm._v(" "),
      _c(
        "el-row",
        { staticStyle: { padding: "21px 16px" } },
        [
          _c(
            "el-col",
            {
              staticStyle: { display: "flex", "justify-content": "center" },
              attrs: { span: 24 }
            },
            [
              _c("span", { staticClass: "reserve-property-title" }, [
                _vm._v("Reserve the property")
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "el-col",
            {
              staticStyle: { display: "flex", "margin-top": "30px" },
              attrs: { span: 24 }
            },
            [
              _c("span", { staticClass: "reserve-property-desc" }, [
                _vm._v(
                  "To ensure that this property is secured, the purchaser is entitled to\n        place a reservation on the property for a 7day exclusive period, free\n        of competition, to seek advice and proceed with the sale."
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "el-col",
            {
              staticStyle: {
                display: "flex",
                "flex-direction": "column",
                "margin-top": "40px"
              },
              attrs: { span: 24 }
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn-enquire",
                  on: {
                    click: function($event) {
                      _vm.contactDialogVisible = true
                    }
                  }
                },
                [_vm._v("Contact Agent")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            {
              staticStyle: {
                display: "flex",
                "flex-direction": "column",
                "margin-top": "18px"
              },
              attrs: { span: 24 }
            },
            [
              (_vm.listingDetails.price == 0 &&
                _vm.listingDetails.maxPrice == 0) ||
              (!_vm.listingDetails.price && !_vm.listingDetails.maxPrice) ||
              (_vm.listingDetails.price &&
                _vm.listingDetails.price != 0 &&
                _vm.listingDetails.maxPrice &&
                _vm.listingDetails.maxPrice != 0 &&
                _vm.listingDetails.price != _vm.listingDetails.maxPrice)
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "track",
                          rawName: "v-track:101.click",
                          value: _vm.reserveTheProperty,
                          expression: "reserveTheProperty",
                          arg: "101",
                          modifiers: { click: true }
                        }
                      ],
                      staticClass: "btn-reserve"
                    },
                    [_vm._v("\n        Select Now\n      ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              (_vm.listingDetails.price &&
                _vm.listingDetails.price != 0 &&
                !_vm.listingDetails.maxPrice) ||
              (_vm.listingDetails.price &&
                _vm.listingDetails.price != 0 &&
                _vm.listingDetails.maxPrice == 0) ||
              (_vm.listingDetails.price &&
                _vm.listingDetails.price != 0 &&
                _vm.listingDetails.maxPrice &&
                _vm.listingDetails.maxPrice != 0 &&
                _vm.listingDetails.price == _vm.listingDetails.maxPrice)
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "track",
                          rawName: "v-track:101.click",
                          value: _vm.reserveTheProperty2,
                          expression: "reserveTheProperty2",
                          arg: "101",
                          modifiers: { click: true }
                        }
                      ],
                      staticClass: "btn-reserve"
                    },
                    [_vm._v("\n        Select Now\n      ")]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-484129ef", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-484129ef","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/propertyDetails/reserveProperty.vue
// module id = null
// module chunks = 